<template>
    <div id="personal-information" class="tab-pane fade active show">
        <div class="row">
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Salutation</label>
                <p class="mg-b-0">{{ client.salutation|placeholder }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">First name</label>
                <p class="mg-b-0">{{ client.first_name|placeholder }}</p>
            </div>
            <div class="col-md-4 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Last name</label>
                <p class="mg-b-0">{{ client.last_name|placeholder }}</p>
            </div>
            <div class="col-md-4 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Additional names</label>
                <p class="mg-b-0">{{ client.additional_names|placeholder }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Gender</label>
                <p class="mg-b-0">{{ gender|placeholder }}</p>
            </div>
            <div class="col-md-4 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Birth Date</label>
                <p class="mg-b-0">{{ client.birth_date|placeholder }}</p>
            </div>
            <div class="col-md-4 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Nationality</label>
                <p class="mg-b-0">{{ client.nationality|placeholder }}</p>
            </div>
        </div>

        <h6 class="mg-t-40 mg-b-20">Contact Details</h6>
        <div class="row">
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Email Address</label>
                <p class="tx-primary mg-b-0">{{ client.email|placeholder }}</p>
            </div>
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Phone</label>
                <p class="tx-primary tx-rubik mg-b-0">{{ client.phone|placeholder }}</p>
            </div>
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Other Phone</label>
                <p class="tx-primary tx-rubik mg-b-0">{{ client.other_phone|placeholder }}</p>
            </div>
        </div>

        <h6 class="mg-t-40 mg-b-20">Location Details</h6>
        <div class="row">
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Country</label>
                <p class="tx-primary tx-rubik mg-b-0">{{ client.country_details.name|placeholder }}</p>
            </div>
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">City</label>
                <p class="tx-primary tx-rubik mg-b-0">{{ client.city_details.name|placeholder }}</p>
            </div>
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Address</label>
                <p class="mg-b-0">{{ client.address_line_1 }}<br>{{ client.address_line_2 }}<br>{{ client.address_line_3 }}</p>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		computed: {
			gender: function() {
				if (this.client.gender) {
					return this.client.gender.toLowerCase() === "m"
						? "Male"
						: "Female";
				}

				return this.client.gender;
			}
		},
		props: ["client"]
	};
</script>